/**
 * Context the file is used in in the app.
 */
export var FileContext;
(function (FileContext) {
    FileContext["CompanyInsured"] = "company-insured";
    FileContext["CompanyDebtor"] = "company-debtor";
})(FileContext || (FileContext = {}));
